import {CategoryDefinitionId, IFilterCategoryDefinition} from "./filter-category-definition.interface";
import {GameInfo} from "../../games/game-info";
import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {ApplyGameFilterResult, IGameFilterEvaluator} from "../evaluators/game-filter-evaluator.interface";
import {OR} from "../evaluators/or-game-filters-evaluator";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {AND} from "../evaluators/and-game-filters-evaluator";

export abstract class FilterCategoryDefinitionBase implements IFilterCategoryDefinition {
    constructor(protected readonly services: IServiceFactoryExtended) {
        this.availableFilters = this._loadAvailableFilters();
    }

    abstract get id(): CategoryDefinitionId;
    abstract get title(): string;
    protected abstract _loadAvailableFilters(): IGameFilterDefinition[];

    readonly availableFilters: IGameFilterDefinition[];

    get hasItsOwnFiltersOrder(): boolean {
        return false;
    }

    protected _getAppliedSubFiltersForFilter(filter: IGameFilterDefinition, appliedSubFilters: IGameFilterDefinition[]): IGameFilterDefinition[] {
        if(filter.subFilters.length === 0) {
            return [];
        }

        const result: IGameFilterDefinition[] = [];

        for(let appliedSubFilter of appliedSubFilters) {
            const subFilter = filter.subFilters.find(sf => sf.id === appliedSubFilter.id);
            if(subFilter) {
                result.push(subFilter);
            }
        }

        return result;

    }

    applyFilters(gameInfo: GameInfo, appliedFilters: IGameFilterDefinition[], appliedSubFilters: IGameFilterDefinition[]): ApplyGameFilterResult {

        const filterEvaluators: IGameFilterEvaluator[] = [];

        for(let filter of appliedFilters) {
            const appliedSubFiltersForCurrentFilter = this._getAppliedSubFiltersForFilter(filter, appliedSubFilters);
            if(appliedSubFiltersForCurrentFilter.length > 0) {
                filterEvaluators.push(AND(filter, OR(...appliedSubFiltersForCurrentFilter)));
            } else {
                filterEvaluators.push(filter)
            }
        }

        return OR(...filterEvaluators).applyFilter(gameInfo);
    }

    get isMultiSelect(): boolean {
        return true;
    }
}